const selectIpRangeListData = (state) => state.settings.simulator.ignoreIpRange.ipRangeListData
const selectIpModalData = (state) => state.settings.simulator.ignoreIpRange.ipModalData

export { selectIpRangeListData, selectIpModalData }
